import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography"; // CUSTOM UTILS LIBRARY FUNCTION
import { formatMoney } from "src/lib/utils";
import ListItem from "./list-item"; // GLOBAL CUSTOM COMPONENTS
import { useGlobalContext } from "src/lib/components/salify-next-layout/default/global-context";
import { PromotionResultType } from "src/lib/fetcher/client";

export const CheckoutSummary = () => {
  const { getPrice, promotionResult } = useGlobalContext();
  const price = getPrice();
  const shippingPrice = price.shipping;
  const finalPrice = price.amount;
  const totalPrice = price.price;
  const tax = price.tax;
  const discount = price.discount;
  let label = "Phí vận chuyển";
  if (
    shippingPrice === 0 &&
    promotionResult &&
    promotionResult.code &&
    promotionResult.code.length &&
    promotionResult.resultType === PromotionResultType.FreeShipping
  ) {
    label += " (Mã vận chuyển 0 đồng) ";
  }
  return (
    <Card sx={{ p: 3 }}>
      <SalifyFallback.Label
        path="Subtotal"
        default="Tổng giá sản phẩm"
        render={(label) => <ListItem mb={1} title={label} value={totalPrice} />}
      />
      <SalifyFallback.Label
        path="Shipping"
        default={label}
        render={(label) => <ListItem mb={1} title={label} value={shippingPrice} />}
      />
      <SalifyFallback.Label
        path="Tax"
        default="Thuế"
        render={(label) => <ListItem mb={1} title={label} value={tax} />}
      />
      <SalifyFallback.Label
        path="Discount"
        default="Giảm giá"
        render={(label) => <ListItem mb={1} title={label} value={discount} />}
      />

      <Divider sx={{ my: 2 }} />

      <Paragraph fontSize={25} fontWeight={600} lineHeight={1}>
        {formatMoney(finalPrice)}
      </Paragraph>
    </Card>
  );
};

export default CheckoutSummary;
